import DamageActions from './actions';
import lodash from 'lodash';
import firebase from 'firebase/app';
import * as uuid from 'uuid';
import { dispatch, getState } from '../..';
import DamageHelper, { IDamage } from '../../../types/model/masterData/damage';
import GeneralFunctions from '../../general/functions';

export default class DamageFunctions {
    private static listener ?: () => void;

    public static getList = (refresh ?: boolean) => {

        if (!refresh && DamageFunctions.listener) {
            return;
        }

        if (DamageFunctions.listener) {
            DamageFunctions.listener();
        }

        dispatch(DamageActions.setLoading(true));
        dispatch(DamageActions.setList([]));

        try {
            
            DamageFunctions.listener = DamageHelper
                .collection()
                .onSnapshot((snapshot) => {
                    const damageState = getState().masterData.damage;

                    const damages = damageState.damages.slice();

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const data = f.doc.data();
                        const index = lodash.findIndex(damages, n => n.id === data.id);

                        switch (f.type) {
                        case 'added':
                            damages.push(data);
                            break;
                        case 'modified':
                            damages.splice(index, 1, data);
                            break;
                        case 'removed':
                            damages.splice(index, 1);
                            break;
                        }
                    });

                    dispatch(DamageActions.setList(damages));
                    dispatch(DamageActions.setLoading(false));
                }, (err) => {
                    GeneralFunctions.generalShowErrorSnackbar('An error while loading damages.', err);
                });

        } catch (ex) {
            GeneralFunctions.generalShowErrorSnackbar('An error while loading damages.', ex);
            dispatch(DamageActions.setLoading(false));
        }
    }

    public static save = async (item : IDamage) => {
        const session = getState().auth.session;

        if (!session) return;
        
        const damages = getState().masterData.damage.damages;

        if (damages.some(x => x.name === item.name && x.id !== item.id)) {
            throw new Error('Diseas already exists.');
        }

        dispatch(DamageActions.setLoading(true));

        try {
            const save : IDamage = {
                ...item,
                createdBy: item.createdBy ? item.createdBy : session.firebaseUser.uid,
                createdByEmployee: item.createdByEmployee ? item.createdByEmployee : session.user.employeeNumber,
                createdByName: item.createdBy ? item.createdByName : session.user.name,
                createdOn: item.createdOn ? item.createdOn : firebase.firestore.Timestamp.now().toMillis(),
                updatedBy: session.firebaseUser.uid,
                updatedByEmployee: session.user.employeeNumber,
                updatedByName: session.user.name,
                updatedOn: firebase.firestore.Timestamp.now().toMillis(),
                id: item.id ? item.id : uuid.v4(),
            };

            await DamageHelper.save(save);
        } catch (ex) {
            GeneralFunctions.generalShowErrorSnackbar('An error while saving damage.', ex);
            throw ex;
        } finally {
            dispatch(DamageActions.setLoading(false));
        }
    }
}